// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_i8-0";
export var buttonContainer = "_i8-3";
export var cancelButton = "_i8-4";
export var headerSection = "_i8-6";
export var headerTitle = "_i8-9";
export var messageSideLeft = "_i8-1";
export var messageSideRight = "_i8-2";
export var orderNumberContainer = "_i8-7";
export var orderNumberLabel = "_i8-8";
export var submitButton = "_i8-5";